import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {} from "../../store/actions";

import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import logo from "../../assets/images/logo.svg";
import logoLightPng from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/logo-dark.png";
import MobiLogo from "../../assets/images/brands/MobihunterLight.png";
import CreativeCircle from "../../assets/images/brands/logotype.png";
import { SERVER_POSITION } from "../../helpers/api_helper";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <div className="vertical-menu">
          <div className="navbar-brand-box" style={{ width: "280px" }}>
            <Link to="/" className="logo logo-dark">
              <span className="logo-sm">
                <img src={logo} alt="" height="22" />
              </span>
              <span className="logo-lg">
                <img src={logoDark} alt="" height="17" />
              </span>
            </Link>

            <Link to="/" className="logo logo-light">
              <span className="logo-sm">
                <img src={CreativeCircle} alt="" height="22" />
              </span>
              <span className="logo-lg align-content-center">
                <img src={MobiLogo} alt="" height="28" />
                {SERVER_POSITION === 'dev' && (
                  <b
                    className="dev"
                    style={{
                      position: "relative",
                      bottom: "-2px",
                      color: "#ff6a6a",
                      fontSize: '17px'
                    }}
                  >
                    dev
                  </b>
                )}
              </span>
            </Link>
          </div>
          <div data-simplebar className="h-100">
            {this.props.type !== "condensed" ? (
              <SidebarContent permissions={this.props.permissions} />
            ) : (
              <SidebarContent permissions={this.props.permissions} />
            )}
          </div>
          <div className="sidebar-background"></div>
        </div>
      </React.Fragment>
    );
  }
}

Sidebar.propTypes = {
  type: PropTypes.string,
  permissions: PropTypes.any,
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
    permissions: state.User.permissions,
  };
};
export default connect(
  mapStateToProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
